import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const Home = () => {
    const navigate = useNavigate();

    return (

        <div className="container">
            <Header />
            <h2>Home Page</h2>
            <button onClick={() => navigate("/login")} className="btn btn-primary">
                Pergi ke Login
            </button>
        </div>
    );
};

export default Home;
